// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2mlfJ","addWidgetButton":"Header_addWidgetButton__UTFGv","dashboardTabs":"Header_dashboardTabs__1rE8K","active":"Header_active__1RdTn"};